export const Logo = require("../src/Assets/Logo.png");
export const homeBanner =require('../src/Assets/home-banner.png')
export const HelpImage = require("../src/Assets/atum2.jpg");
export const ContactUs = require("../src/Assets/tech-bg.jpg");
export const serviceBannerImg = require("../src/Assets/servicePageImg2.png");
export const serviceBannerImg1 = require("../src/Assets/serviceImg1.png");
export const serviceBannerImg2 = require("../src/Assets/serviceImg4.png");
export const male=require('../src/Assets/male.JPG');
export const testimonials1=require('../src/Assets/testimonials-1.png');
export const testimonials2=require('../src/Assets/testimonials-2.png');
export const testimonials3=require('../src/Assets/testimonials-3.png');
export const aboutUsImg1=require('../src/Assets/aboutUsImg1.png');
export const aboutUsImg2=require('../src/Assets/aboutUsImg2.png');
export const aboutUsImg3=require('../src/Assets/aboutUsImg3.png');
export const webDevelopImg=require('../src/Assets/webDevelopImg1.png');
export const webDevelopImg2=require('../src/Assets/webDevelopImg2.png');
export const Design=require('../src/Assets/Designing.webp');
export const DevelopmentProcess=require('../src/Assets/Development-process.webp');
export const Responsive=require('../src/Assets/Responsive-Web-Designs.webp');
export const one=require('../src/Assets/1-13.webp');
export const two=require('../src/Assets/2-13.webp');
export const three=require('../src/Assets/3-12.webp');
export const Advantages=require('../src/Assets/Advantages-services.webp');
export const Custom=require('../src/Assets/Custom-Web-Development-Solution-Is-What.webp');
export const tech=require('../src/Assets/tech.webp');
export const productbanner=require('../src/Assets/product-banner.webp');
export const value1=require('../src/Assets/value-1.webp');
export const value2=require('../src/Assets/value-2.webp');
export const value3=require('../src/Assets/value-3.webp');
export const PortfolioSubBanner=require('../src/Assets/PortfolioSubBanner.png');
export const PortfolioBanner=require('../src/Assets/PortfolioBanner.png');
export const DesignImage=require('../src/Assets/DesignImage.avif');
export const Testing=require('../src/Assets/Testing.png');
export const Deployment=require('../src/Assets/Deployment.png');
export const Development=require('../src/Assets/Development.png');
export const fullstack=require('../src/Assets/fullstack.png');
export const htmlcss=require('../src/Assets/htmlcss.png');
export const whoweare=require('../src/Assets/whoweare.png');
export const customWebDesign=require('../src/Assets/customWebDesign.png');
export const newImg4=require('../src/Assets/newImg4.png');
export const newImg1=require('../src/Assets/newImg1.png');
export const saas=require('../src/Assets/saas.avif');
export const newImg7=require('../src/Assets/newImg7.png');
export const AtulSir=require('../src/Assets/AtulSir.png');
export const Atulsir_website=require('../src/Assets/Atulsir_website.png');

export const client1=require('../src/Assets/client1.png');
export const client2=require('../src/Assets/client2.png');
export const client3=require('../src/Assets/client3.png');
export const client4=require('../src/Assets/client4.png');
export const client5=require('../src/Assets/client5.png');
export const client6=require('../src/Assets/client6.png');
export const client7=require('../src/Assets/client7.png');
export const client8=require('../src/Assets/client8.png');
export const client9=require('../src/Assets/client 9.webp');
export const client10=require('../src/Assets/client10.jpg');
export const client11=require('../src/Assets/client11.png');
export const client12=require('../src/Assets/client12.png');
export const client13=require('../src/Assets/client13.webp');
export const client14=require('../src/Assets/client14.webp');

export const Approach1=require('../src/Assets/Approach1.png');
export const Approach2=require('../src/Assets/Approach2.png');
export const Approach3=require('../src/Assets/Approach3.png');
export const Approach4=require('../src/Assets/Approach4.png');
export const Approach5=require('../src/Assets/Approach5.png');
export const Approach6=require('../src/Assets/Approach6.png');

export const service1=require('../src/Assets/service1.png');
export const service2=require('../src/Assets/service2.png');
export const service3=require('../src/Assets/service3.png');
export const service4=require('../src/Assets/service4.png');
export const service5=require('../src/Assets/service5.png');
export const service6=require('../src/Assets/service6.png');
export const service7=require('../src/Assets/service7.png');
export const service8=require('../src/Assets/service8.png');

export const support1=require('../src/Assets/suppprt1.png');
export const support2=require('../src/Assets/suppprt2.png');
export const support3=require('../src/Assets/suppprt3.png');
export const support4=require('../src/Assets/suppprt4.png');

export const saasBanner=require('../src/Assets/saas.png');
export const DM1=require('../src/Assets/DM1.png');
export const DM2=require('../src/Assets/DM2.png');
export const DM3=require('../src/Assets/DM3.png');
export const DM4=require('../src/Assets/DM4.png');
export const DM5=require('../src/Assets/DM5.png');

export const ECommerce=require('../src/Assets/E-Commerce-Services.png');
export const ECommerce1=require('../src/Assets/ECommerce1.png');
export const ECommerce2=require('../src/Assets/ECommerce2.png');
export const ECommerce3=require('../src/Assets/ECommerce3.png');
export const ECommerce4=require('../src/Assets/ECommerce4.png');
export const ECommerce5=require('../src/Assets/ECommerce5.png');

export const ec1=require('../src/Assets/ec1.png');
export const ec2=require('../src/Assets/ec2.png');
export const ec3=require('../src/Assets/ec3.png');
export const ec4=require('../src/Assets/ec4.png');
export const ec5=require('../src/Assets/ec5.png');
export const ec6=require('../src/Assets/ec6.png');
export const ec7=require('../src/Assets/ec7.png');
export const ec8=require('../src/Assets/ec8.png');

export const fd1=require('../src/Assets/fd1.png');
export const fd2=require('../src/Assets/fd2.png');
export const fd3=require('../src/Assets/fd3.png');

export const Discovery=require('../src/Assets/Discovery.png');

export const MobileAppBanner=require('../src/Assets/Mobile-App-Development.png');
export const Vulnerability=require('../src/Assets/Vulnerability.png');

export const m1=require('../src/Assets/m1.png');
export const m2=require('../src/Assets/m2.png');
export const m3=require('../src/Assets/m3.png');

export const m25=require('../src/Assets/m25.png');
export const m26=require('../src/Assets/m26.png');
export const m27=require('../src/Assets/m27.png');
export const m28=require('../src/Assets/m28.png');

export const OurClient=require('../src/Assets/Our-Client.png');

export const planning1=require('../src/Assets/Planning.png');
export const planning2=require('../src/Assets/p2.png');
export const planning3=require('../src/Assets/P3.png');
export const planning4=require('../src/Assets/p4.png');
export const planning5=require('../src/Assets/p5.png');


export const Product1=require('../src/Assets/MilkApp.png');
export const Product3=require('../src/Assets/matrimono.png');
export const Product2=require('../src/Assets/flexa.png');
export const Product4=require('../src/Assets/Ecommerce.png');

export const digilogo = require('./Assets/digilogo.webp');
export const unitreeLogo = require('./Assets/unitreelogo.png');
